import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as artists from '@webapp/sdk/artists';
import { Action } from 'redux';
import { PublishArtistPage, PublishArtistPageSuccess, PublishArtistPageError } from '../action-creators';
import { PUBLISH_ARTIST_PAGE } from '../actions';
import AppState from '@webapp/store/state';
import { NoOp } from '@webapp/store/ui/action-creators';
import SimpleArtist from '@common/types/artist/simple-artist';


export const publishArtistPageEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
action$.pipe(
    ofType<Action, PublishArtistPage>(PUBLISH_ARTIST_PAGE),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      if (!state.artist.active?.id) {
        return new NoOp();
      }

      const subdomain = state.subdomain.currentSubdomain?.subdomain;

      action.page.subdomain = subdomain ? subdomain : action.page.subdomain;

      try {
        await artists.publishPage(state.artist.active as SimpleArtist, action.page);

        return new PublishArtistPageSuccess();
      } catch (err) {
        return new PublishArtistPageError(err.message)
      }
    })
  );